/** @deprecated Quarantined legacy (WEB-8048) — moved out of the Angular tree so the ReactTemplates.admin global survives Phase 6. Do not import in new code. */
'use strict';
import T from 'Components/Helpers/translate';
import SaveBtn from 'Components/Admin/SaveBtn';
import { assertRemovable } from 'Helpers/logError';

ReactTemplates.admin = ReactTemplates.admin || {};
const AdminRoot = window.ReactCreateClass({
	getInitialState: function () {
		return {};
	},
	UNSAFE_componentWillMount: function () {
		var t = T;
		this.lang = {
			admin: t('default.admin')
		};
	},
	setRef: function (name, ref) {
		this[name] = ref;
	},
	render: function () {
		var self = this;
		const { tools, rootData, initialImport } = this.props;
		const btnData = initialImport || rootData;

		if (!(typeof self.props.pageComponent === 'function') && rootData.useWebPack) {
			assertRemovable(`AdminRoot.render window['${self.props.pageComponent}']`);
		}

		var pageComponent = React.createElement(
			typeof self.props.pageComponent === 'function'
				? self.props.pageComponent
				: rootData.useWebPack
				? window[self.props.pageComponent]
				: ReactTemplates.admin[self.props.pageComponent],
			{
				rootData: rootData,
				staticData: this.props.staticData,
				tools: tools
			}
		);

		var saveBtn = (
			<SaveBtn
				visible={rootData.saveVisible}
				saving={btnData.saving}
				onClick={btnData.onSave}
				text={btnData.saveBtnText || null}
				disabledReasons={btnData.getDisabledReasons?.() || []}
			/>
		);

		var loader = (
			<div id="admin-loader" className={rootData.pageLoading ? 'visible' : null}>
				{React.createElement(ReactTemplates.loader, {})}
			</div>
		);

		return (
			<div className={Tools.browserService.isTouchDevice ? 'is-touch' : null}>
				<div id="component-wrapper" className={rootData.pageLoading ? null : 'visible'}>
					{pageComponent}
				</div>
				{saveBtn}
				{loader}
			</div>
		);
	}
});

export default AdminRoot;
